"use client";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
// Templates persisted before backend started writing the full TextNode shape
// (notably `mode`) leave `__mode = undefined` after Lexical's importJSON. That
// makes TextNode.isSimpleText() return false, which silently disables the
// variable typeahead inside those nodes. Walk the JSON once on load and
// backfill the fields Lexical's TextNode.updateFromJSON consumes so typing
// `{{` inside template text reliably opens the suggestion menu.
function normalizeTextNodeDefaults(node) {
    if (!node || typeof node !== 'object')
        return;
    const record = node;
    if (record.type === 'text') {
        if (record.mode === undefined)
            record.mode = 'normal';
        if (record.format === undefined)
            record.format = 0;
        if (record.detail === undefined)
            record.detail = 0;
        if (record.style === undefined)
            record.style = '';
    }
    const children = record.children;
    if (Array.isArray(children)) {
        for (const child of children)
            normalizeTextNodeDefaults(child);
    }
}
function normalizeLexicalJson(serialized) {
    try {
        const parsed = JSON.parse(serialized);
        if (parsed?.root)
            normalizeTextNodeDefaults(parsed.root);
        return JSON.stringify(parsed);
    }
    catch {
        return serialized;
    }
}
export function InitialStatePlugin({ initialContent }) {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        if (initialContent) {
            try {
                const normalized = normalizeLexicalJson(initialContent);
                const editorState = editor.parseEditorState(normalized);
                editor.setEditorState(editorState);
            }
            catch (error) {
                console.error('Error parsing initial content:', error);
            }
        }
        // Only run once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editor]);
    return null;
}
